import Romy from "../../images/romy.jpg";
import WelcomeJson from "../../data/welcome.json";
import ContactJson from "../../data/contact.json";
import { useEffect, useState } from "react";
import { ContactContent } from "../../shared/types";

type WelcomeContent = {
  headline: string;
  content: string;
};

function Welcome() {
  const [welcome, setWelcome] = useState<WelcomeContent>();
  const [contact, setContact] = useState<ContactContent>();

  useEffect(() => {
    setWelcome(WelcomeJson);
    setContact(ContactJson);
  }, []);

  return (
    <div className="grid grid-cols-1 bg-gray-100 pb-8 lg:grid-cols-12 lg:pt-16 lg:pb-16">
      {/* Desktop-only dark panel behind photo */}
      <div className="hidden col-span-1 col-start-1 row-start-1 bg-gradient-to-b from-gray-900 to-gray-800 rounded-r-lg lg:block lg:col-start-1 lg:col-span-6 xl:col-start-1 xl:col-span-5 2xl:col-start-1 2xl:col-span-4"></div>

      {/* Text + contact */}
      <div className="col-span-1 col-start-1 row-start-2 flex flex-col items-center px-6 py-8 lg:justify-center lg:w-full lg:py-0 lg:items-start lg:row-start-1 lg:col-start-8 lg:col-span-5 xl:col-start-7 xl:col-span-6 2xl:col-start-6 2xl:col-span-7">
        <div className="text-center lg:text-left lg:max-w-sm xl:max-w-xl 2xl:max-w-2xl">
          <div className="mb-5">
            <p className="text-petrol-400 text-xs font-bold tracking-widest uppercase mb-2">
              Mein Motto
            </p>
            <p className="font-Forum italic tracking-tight text-4xl xl:text-5xl text-petrol-700 2xl:text-6xl leading-tight">
              {welcome?.headline}
            </p>
          </div>
          <p className="text-center text-lg text-gray-500 2xl:text-xl lg:text-left">
            {welcome?.content}
          </p>
        </div>
        <div className="flex flex-col gap-3 mt-6 lg:mt-8">
          <a
            href={`tel:${contact?.phone?.replace(/\s/g, "")}`}
            className="flex items-center gap-3 text-gray-700 hover:text-petrol-600 transition-colors"
          >
            <div className="w-9 h-9 rounded-full bg-petrol-100 flex items-center justify-center flex-none">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="w-4 h-4 text-petrol-600"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                strokeWidth={2}
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"
                />
              </svg>
            </div>
            <span className="font-medium 2xl:text-lg">{contact?.phone}</span>
          </a>
          <a
            href={`mailto:${contact?.email}`}
            className="flex items-center gap-3 text-gray-700 hover:text-petrol-600 transition-colors"
          >
            <div className="w-9 h-9 rounded-full bg-petrol-100 flex items-center justify-center flex-none">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="w-4 h-4 text-petrol-600"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                strokeWidth={2}
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
                />
              </svg>
            </div>
            <span className="font-medium 2xl:text-lg">{contact?.email}</span>
          </a>
        </div>
      </div>

      {/* Photo — dark bg on mobile, transparent on desktop (desktop dark panel handles it) */}
      <div className="row-start-1 col-span-1 bg-gradient-to-b from-gray-900 to-gray-800 px-6 py-10 lg:bg-none lg:p-0 lg:mx-6 lg:py-16 lg:row-start-1 lg:col-start-2 lg:col-span-6 xl:col-span-5 xl:col-start-2 2xl:col-start-2 2xl:col-span-4">
        <img
          className="rounded-lg shadow-2xl lg:rounded-r-lg"
          src={Romy}
          alt="Romy Winkler Portrait"
        />
      </div>
    </div>
  );
}

export default Welcome;
